// import React, { useState, useEffect, useRef } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBell, faUserPlus, faShoppingCart, faCog } from "@fortawesome/free-solid-svg-icons";
// import { Link } from "react-router-dom";
// import { URL } from "../../../config";
// import { jwtDecode } from "jwt-decode";

// import "./notificationDropdown.css";

// // Helper function to convert a date into relative time (e.g., "5 min ago")
// function timeSince(dateString) {
//   const date = new Date(dateString);
//   const seconds = Math.floor((new Date() - date) / 1000);

//   if (seconds < 60) return `${seconds} sec${seconds !== 1 ? "s" : ""} ago`;
//   const minutes = Math.floor(seconds / 60);
//   if (minutes < 60) return `${minutes} min${minutes !== 1 ? "s" : ""} ago`;
//   const hours = Math.floor(minutes / 60);
//   if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
//   const days = Math.floor(hours / 24);
//   return `${days} day${days !== 1 ? "s" : ""} ago`;
// }

// const UserNotificationDropdown = () => {
//   const [notifications, setNotifications] = useState([]);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith("user-")
//             ? decodedToken.Id.split("user-")[1]
//             : decodedToken.Id;
//           const response = await fetch(`${URL}/notifications/user/${userId}`);
//           if (response.ok) {
//             const data = await response.json();
//             setNotifications(data);
//           } else {
//             console.error("Failed to fetch notifications");
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       }
//     };

//     fetchNotifications();
//     const intervalId = setInterval(fetchNotifications, 60000);
//     return () => clearInterval(intervalId);
//   }, []);

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setDropdownOpen(false);
//       }
//     };
//     if (dropdownOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//     } else {
//       document.removeEventListener("mousedown", handleClickOutside);
//     }
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownOpen]);

//   const getNotificationIcon = (type) => {
//     switch (type) {
//       case "user":
//         return faUserPlus;
//       case "order":
//         return faShoppingCart;
//       case "system":
//         return faCog;
//       default:
//         return faBell;
//     }
//   };

//   return (
//     <div className="usernotificationdropdown-container" ref={dropdownRef}>
//       <div
//         className="usernotificationdropdown-icon"
//         onClick={() => setDropdownOpen(!dropdownOpen)}
//       >
//         <FontAwesomeIcon icon={faBell} />
//         {notifications.length > 0 && (
//           <span className="usernotificationdropdown-count">
//             {notifications.length}
//           </span>
//         )}
//       </div>
//       {dropdownOpen && (
//         <div className="usernotificationdropdown-menu">
//           <div className="usernotificationdropdown-header">
//             <h6>Notifications</h6>
//             <span>{notifications.length} New</span>
//           </div>
//           <ul className="usernotificationdropdown-list">
//             {notifications.length > 0 ? (
//               notifications.map((notif) => (
//                 <li key={notif.id} className="usernotificationdropdown-item">
//                   <div className="usernotificationdropdown-icon-wrapper">
//                     <FontAwesomeIcon icon={getNotificationIcon(notif.type)} />
//                   </div>
//                   <div className="usernotificationdropdown-content">
//                     <p className="usernotificationdropdown-message">
//                       {notif.message}
//                     </p>
//                     <span className="usernotificationdropdown-time">
//                       {timeSince(notif.createdAt)}
//                     </span>
//                   </div>
//                 </li>
//               ))
//             ) : (
//               <li className="usernotificationdropdown-item">
//                 No new notifications
//               </li>
//             )}
//           </ul>
//           <div className="usernotificationdropdown-footer">
//             <Link to="/profile/notifications" className="usernotificationdropdown-view-all">
//               View All Notifications
//             </Link>
//             {notifications.length > 0 && (
//               <button
//                 className="usernotificationdropdown-clear"
//                 onClick={() => setNotifications([])}
//               >
//                 Clear All
//               </button>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UserNotificationDropdown;



// ***** Checked All is okay and working fine (24-6-25) ***** //

// import React, { useState, useEffect, useRef } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBell, faUserPlus, faShoppingCart, faCog } from "@fortawesome/free-solid-svg-icons";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import "./notificationDropdown.css";

// // Helper function to convert a date into relative time (e.g., "5 min ago")
// function timeSince(dateString) {
//   const date = new Date(dateString);
//   const seconds = Math.floor((new Date() - date) / 1000);
//   if (seconds < 60) return `${seconds} sec${seconds !== 1 ? "s" : ""} ago`;
//   const minutes = Math.floor(seconds / 60);
//   if (minutes < 60) return `${minutes} min${minutes !== 1 ? "s" : ""} ago`;
//   const hours = Math.floor(minutes / 60);
//   if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
//   const days = Math.floor(hours / 24);
//   return `${days} day${days !== 1 ? "s" : ""} ago`;
// }

// const UserNotificationDropdown = () => {
//   const [notifications, setNotifications] = useState([]);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);
//   const dropdownRef = useRef(null);
//   const navigate = useNavigate();
  

//   // Fetch notifications for the user
//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith("user-")
//             ? decodedToken.Id.split("user-")[1]
//             : decodedToken.Id;
//           const response = await axios.get(`${URL}/notifications/user/${userId}`);
//           if (response.status === 200) {
//             setNotifications(response.data);
//             const unreadCount = response.data.filter((n) => !n.isRead).length;
//             setHasUnreadNotifications(unreadCount > 0); 
//           } else {
//             console.error("Failed to fetch notifications");
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       }
//     };

//     fetchNotifications();
//     const intervalId = setInterval(fetchNotifications, 60000); // Refresh every minute
//     return () => clearInterval(intervalId);
//   }, []);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setDropdownOpen(false);
//       }
//     };
//     if (dropdownOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//     } else {
//       document.removeEventListener("mousedown", handleClickOutside);
//     }
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownOpen]);

//   // Handler to mark a notification as read
//   const handleMarkAsRead = async (notificationId) => {
//     try {
//       const response = await axios.patch(`${URL}/notifications/${notificationId}/read`);
//       if (response.status === 200) {
//         // Update local state to mark this notification as read
//         setNotifications((prevNotifications) =>
//           prevNotifications.map((notif) =>
//             notif.Id === notificationId ? { ...notif, isRead: true } : notif
//           )
//         );
//       }
//     } catch (error) {
//       console.error("Error marking notification as read:", error);
//     }
//   };

//   const getNotificationIcon = (type) => {
//     // You can adjust the mapping based on your notification "type"
//     switch (type) {
//       case "order_accepted":
//         return faShoppingCart;
//       case "deadline_extended":
//         return faCog;
//       case "order_cancelled":
//         return faUserPlus;
//       default:
//         return faBell;
//     }
//   };

//   return (
//     <div className="usernotificationdropdown-container" ref={dropdownRef}>
//       <div
//         // className="usernotificationdropdown-icon"
//         className={`usernotificationdropdown-icon ${hasUnreadNotifications ? "bellShake" : ""}`}
//         onClick={() => setDropdownOpen(!dropdownOpen)}
//       >
//         <FontAwesomeIcon icon={faBell} />
//         {notifications.some((n) => !n.isRead) && (
//           <span className="usernotificationdropdown-count">
//             {notifications.filter((n) => !n.isRead).length}
//           </span>
//         )}
//       </div>
//       {dropdownOpen && (
//         <div className="usernotificationdropdown-menu">
//           <div className="usernotificationdropdown-header">
//             <h6>Notifications</h6>
//             <span>{notifications.filter((n) => !n.isRead).length} New</span>
//           </div>
//           <ul className="usernotificationdropdown-list">
//             {notifications.length > 0 ? (
//               notifications.map((notif) => (
//                 <li
//                   key={notif.Id}
//                   className={`usernotificationdropdown-item position-relative ${
//                     notif.isRead ? "" : "usernotification-unread"
//                   }`}
//                   onClick={() => {
//                     handleMarkAsRead(notif.Id);
//                     navigate("/profile/notifications");
//                     setDropdownOpen(false);
//                   }}
//                 >
//                   <div className="usernotificationdropdown-icon-wrapper">
//                     <FontAwesomeIcon icon={getNotificationIcon(notif.type)} />
//                   </div>
//                   <div className="usernotificationdropdown-content">
//                     <p className="usernotificationdropdown-message">
//                       {notif.message}
//                     </p>
//                     <span className="usernotificationdropdown-time">
//                       {timeSince(notif.created_at)}
//                     </span>
//                   </div>
//                 </li>
//               ))
//             ) : (
//               <li className="usernotificationdropdown-item">
//                 No new notifications
//               </li>
//             )}
//           </ul>
//           <div className="usernotificationdropdown-footer">
//             <Link to="/profile/notifications" className="usernotificationdropdown-view-all"  onClick={() => setDropdownOpen(false)}>
//               View All Notifications
//             </Link>
//             {notifications.length > 0 && (
//               <button
//                 className="usernotificationdropdown-clear"
//                 onClick={() => setNotifications([])}
//               >
//                 Clear All
//               </button>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UserNotificationDropdown;

// ***** Upper code all is okay Checked (24-6-25) ***** //






// ***** Translate Added EN BN (24-6-25) ***** //


// import React, { useState, useEffect, useRef } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faBell,
//   faUserPlus,
//   faShoppingCart,
//   faCog,
// } from "@fortawesome/free-solid-svg-icons";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import "./notificationDropdown.css";
// import { useTranslation } from "react-i18next";

// // Helper function to convert a date into relative time (e.g., "5 min ago")
// function timeSince(dateString) {
//   const date = new Date(dateString);
//   const seconds = Math.floor((new Date() - date) / 1000);
//   if (seconds < 60) return `${seconds} sec${seconds !== 1 ? "s" : ""} ago`;
//   const minutes = Math.floor(seconds / 60);
//   if (minutes < 60) return `${minutes} min${minutes !== 1 ? "s" : ""} ago`;
//   const hours = Math.floor(minutes / 60);
//   if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
//   const days = Math.floor(hours / 24);
//   return `${days} day${days !== 1 ? "s" : ""} ago`;
// }

// const UserNotificationDropdown = () => {
//   const { t } = useTranslation();

//   const [notifications, setNotifications] = useState([]);
//   const [showAll, setShowAll] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);
//   const dropdownRef = useRef(null);
//   const navigate = useNavigate();

//   // Fetch notifications for the user
//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith("user-")
//             ? decodedToken.Id.split("user-")[1]
//             : decodedToken.Id;
//           const response = await axios.get(
//             `${URL}/notifications/user/${userId}`
//           );
//           if (response.status === 200) {
//             // setNotifications(response.data);
//             const enhancedNotifications = await Promise.all(
//               response.data.map(async (notif) => {
//                 let servitorFirstName,
//                   servitorLastName,
//                   priceDelta,
//                   newTotal,
//                   minutesAdded,
//                   newDeadline;
//                 // ADDED: Fetch servitor details for order_in_progress if recipientType is user
//                 if (
//                   notif.type === "order_in_progress" &&
//                   notif.recipientType === "user"
//                 ) {
//                   if (notif.servitorId) {
//                     try {
//                       const servitorResponse = await axios.get(
//                         `${URL}/servitors/${
//                           notif.servitorId.split("servitor-")[1]
//                         }`
//                       );
//                       if (servitorResponse.status === 200) {
//                         const servitorData = servitorResponse.data;
//                         servitorFirstName = servitorData.FirstName || "Unknown";
//                         servitorLastName = servitorData.LastName || "";
//                       } else {
//                         // ADDED: Fallback to parsing message with regex
//                         const match = notif.message.match(
//                           /accepted by ([^\s]+)\s*([^\s]*)/
//                         );
//                         servitorFirstName = match ? match[1] : "Unknown";
//                         servitorLastName = match ? match[2] : "";
//                       }
//                     } catch (error) {
//                       console.error("Error fetching servitor:", error);
//                       // ADDED: Fallback to parsing message with regex
//                       const match = notif.message.match(
//                         /accepted by ([^\s]+)\s*([^\s]*)/
//                       );
//                       servitorFirstName = match ? match[1] : "Unknown";
//                       servitorLastName = match ? match[2] : "";
//                     }
//                   } else {
//                     // ADDED: Fallback to parsing message with regex if no servitorId
//                     const match = notif.message.match(
//                       /accepted by ([^\s]+)\s*([^\s]*)/
//                     );
//                     servitorFirstName = match ? match[1] : "Unknown";
//                     servitorLastName = match ? match[2] : "";
//                   }
//                 }

//                 if (notif.type === "order_updated") {
//                   const d = notif.message?.match(/increased by\s*(\d+)\s*tk/i);
//                   const totalMatch = notif.message?.match(/New total price\s*(\d+)\s*tk/i);
//                   const m = notif.message?.match(/extended by\s*(\d+)\s*minute?s?/i);
//                   const to = notif.message?.match(/new deadline:\s*(.*?)\)/i);
//                   priceDelta = d ? parseInt(d[1], 10) : undefined;
//                   newTotal = totalMatch ? parseInt(totalMatch[1], 10) : undefined;
//                   minutesAdded = m ? parseInt(m[1], 10) : undefined;
//                   newDeadline = to ? to[1] : undefined;
//                 } else if (notif.type === "deadline_extended") {
//                  const m1 = notif.message?.match(/extended to\s*(.+?)(?:\.|$)/i);
//                  const m2 = notif.message?.match(/\(new deadline:\s*(.+?)\)/i);
//                  newDeadline = (m1 && m1[1]) || (m2 && m2[1]) || undefined;
//                 }

//                 return {
//                   ...notif,
//                   servitorFirstName,
//                   servitorLastName,
//                   priceDelta,
//                   newTotal,
//                   minutesAdded,
//                   newDeadline,
//                 };
//               })
//             );
//             setNotifications(enhancedNotifications);

//             const unreadCount = response.data.filter((n) => !n.isRead).length;
//             setHasUnreadNotifications(unreadCount > 0);
//           } else {
//             console.error("Failed to fetch notifications");
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       }
//     };

//     fetchNotifications();
//     const intervalId = setInterval(fetchNotifications, 60000); // Refresh every minute
//     return () => clearInterval(intervalId);
//   }, []);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setDropdownOpen(false);
//       }
//     };
//     if (dropdownOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//     } else {
//       document.removeEventListener("mousedown", handleClickOutside);
//     }
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownOpen]);

//   const toggleShowAll = () => {
//     setShowAll((prev) => !prev);
//   };

//   // Handler to mark a notification as read
//   const handleMarkAsRead = async (notificationId) => {
//     try {
//       const response = await axios.patch(
//         `${URL}/notifications/${notificationId}/read`
//       );
//       if (response.status === 200) {
//         // Update local state to mark this notification as read
//         setNotifications((prevNotifications) =>
//           prevNotifications.map((notif) =>
//             notif.Id === notificationId ? { ...notif, isRead: true } : notif
//           )
//         );
//       }
//     } catch (error) {
//       console.error("Error marking notification as read:", error);
//     }
//   };

//   const handleMarkAllAsRead = async () => {
//     const unread = notifications.filter((n) => !n.isRead);
//     await Promise.all(
//       unread.map((n) => axios.patch(`${URL}/notifications/${n.Id}/read`))
//     );
//     // Update local state in one go:
//     setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
//     setHasUnreadNotifications(false);
//   };

//   // const getNotificationIcon = (type) => {
//   //   // You can adjust the mapping based on your notification "type"
//   //   switch (type) {
//   //     case "order_accepted":
//   //       return faShoppingCart;
//   //     case "deadline_extended":
//   //       return faCog;
//   //     case "order_cancelled":
//   //       return faUserPlus;
//   //     default:
//   //       return faBell;
//   //   }
//   // };

//   const getNotificationIcon = (notif, t) => {
//     const defaults = {
//       icon: faBell,
//       messageKey:
//         notif.type === "service_update"
//           ? "notifications.messages.service_update"
//           : notif.type === "system"
//           ? "notifications.messages.system"
//           : "notifications.messages.notification_default",
//       messageParams: { orderNumber: notif.orderNumber || "" },
//     };

//     switch (notif.type) {
//       case "order_accepted":
//         return {
//           icon: faShoppingCart,
//           messageKey: "notifications.messages.order_accepted",
//           messageParams: { orderNumber: notif.orderNumber },
//         };
//       case "deadline_extended":
//         return {
//           icon: faCog,
//           messageKey: "notifications.messages.deadline_extended",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             // newDeadline: notif.newDeadline
//             // ? new Date(notif.newDeadline).toLocaleString()
//             // : "unknown",
//             newDeadline: notif.newDeadline || t("notifications.unknown"),
//           },
//         };
//       case "order_cancelled":
//         return {
//           icon: faUserPlus,
//           messageKey: notif.message?.includes("no servitor acceptance")
//             ? "notifications.messages.order_cancelled_timeout"
//             : notif.message?.includes("cancelled by the servitor")
//             ? "notifications.messages.order_cancelled_by_servitor"
//             : notif.message?.includes("cancelled by the user")
//             ? "notifications.messages.order_cancelled_by_user"
//             : "notifications.messages.order_cancelled_missed_deadline",
//           messageParams: { orderNumber: notif.orderNumber },
//         };
//       case "deadline_warning_pending":
//         return {
//           icon: faBell,
//           messageKey: "notifications.messages.deadline_warning_pending",
//           messageParams: { orderNumber: notif.orderNumber },
//         };
//       case "order_in_progress":
//         return {
//           icon: faBell,
//           messageKey:
//             notif.recipientType === "user"
//               ? "notifications.messages.order_in_progress_user"
//               : "notifications.messages.order_in_progress_servitor",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             servitorFirstName:
//               notif.servitorFirstName || t("notifications.unknown"),
//             servitorLastName: notif.servitorLastName || "",
//           },
//         };
//       case "order_completed":
//         return {
//           icon: faBell,
//           messageKey:
//             notif.recipientType === "user"
//               ? "notifications.messages.order_completed_user"
//               : "notifications.messages.order_completed_servitor",
//           messageParams: { orderNumber: notif.orderNumber },
//         };
//       case "penalty_applied":
//         return {
//           icon: faBell,
//           messageKey: "notifications.messages.penalty_applied",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             penaltyAmount: notif.penaltyAmount || 40,
//           },
//         };
//       case "account_blocked":
//         return {
//           icon: faBell,
//           messageKey: "notifications.messages.account_blocked",
//           messageParams: {
//             penaltyCount: notif.penaltyCount || 3,
//             penaltyAmount: notif.penaltyAmount || 90,
//           },
//         };
//       case "order_cancelled_with_penalty":
//         return {
//           icon: faBell,
//           messageKey: "notifications.messages.order_cancelled_with_penalty",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             penaltyAmount: notif.penaltyAmount || 30,
//             penaltyCount: notif.penaltyCount || 1,
//           },
//         };
//       case "order_time_warning":
//         return {
//           icon: faBell,
//           messageKey: "notifications.messages.order_time_warning",
//           messageParams: { orderNumber: notif.orderNumber },
//         };

//       case "tutor_accepted":
//         return {
//           icon: faUserPlus,
//           messageKey: "notifications.messages.tutor_accepted",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             servitorFirstName:
//               notif.servitorFirstName || t("notifications.unknown"),
//             servitorLastName: notif.servitorLastName || "",
//           },
//         };
//       case "tutor_user_approved":
//         return {
//           icon: faShoppingCart,
//           messageKey: "notifications.messages.tutor_user_approved",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             servitorFirstName:
//               notif.servitorFirstName || t("notifications.unknown"),
//             servitorLastName: notif.servitorLastName || "",
//           },
//         };
//       case "tutor_hired":
//         return {
//           icon: faCog,
//           messageKey: "notifications.messages.tutor_hired",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             servitorFirstName:
//               notif.servitorFirstName || t("notifications.unknown"),
//             servitorLastName: notif.servitorLastName || "",
//           },
//         };

//       // Optional: order_updated quick message in dropdown
//       case "order_updated":
//         return {
//           icon: faCog,
//           messageKey: "notifications.messages.order_updated",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             priceDelta: notif.priceDelta,
//             newTotal: notif.newTotal,
//             minutesAdded: notif.minutesAdded,
//             // newDeadline: notif.newDeadline
//             //   ? new Date(notif.newDeadline).toLocaleString()
//             //   : undefined,
//             newDeadline: notif.newDeadline
//               ? notif.newDeadline
//               : undefined,
//           },
//         };


//         case "order_rescheduled": {
//         // Parse schedule from message
//         const m1 = notif.message?.match(/rescheduled to\s*(.+?)\.?$/i);
//         const m2 = notif.message?.match(/new schedule:\s*(.+?)\.?$/i);
//         const m3 = notif.message?.match(/\(new deadline:\s*(.+?)\)/i);
//         const newSchedule = (m1 && m1[1]) || (m2 && m2[1]) || (m3 && m3[1]) || t("notifications.unknown");
//         return {
//           icon: faCog,
//           messageKey: "notifications.messages.order_rescheduled",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             newSchedule,
//           },
//         };
//       }
//       case "order_reordered": {
//         const m = notif.message?.match(/new schedule:\s*(.+?)\.?$/i);
//         const newSchedule = (m && m[1]) || t("notifications.unknown");
//         return {
//           icon: faCog,
//           messageKey: "notifications.messages.order_reordered",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             newSchedule,
//           },
//         };
//       }

//       default:
//         return defaults;
//     }
//   };

//   return (
//     <div className="usernotificationdropdown-container" ref={dropdownRef}>
//       <div
//         className={`usernotificationdropdown-icon ${
//           hasUnreadNotifications ? "bellShake" : ""
//         }`}
//         onClick={() => setDropdownOpen(!dropdownOpen)}
//       >
//         <FontAwesomeIcon icon={faBell} />
//         {notifications.some((n) => !n.isRead) && (
//           <span className="usernotificationdropdown-count">
//             {notifications.filter((n) => !n.isRead).length}
//           </span>
//         )}
//       </div>
//       {dropdownOpen && (
//         <div className="usernotificationdropdown-menu">
//           <div className="usernotificationdropdown-header">
//             <h6>{t("notifications.header")}</h6>
//             <span>
//               {t("notifications.new_count", {
//                 count: notifications.filter((n) => !n.isRead).length,
//               })}
//             </span>
//           </div>
//           <ul className="usernotificationdropdown-list">
//             {notifications.length > 0 ? (
//               notifications
//                 .slice(0, showAll ? notifications.length : 5)
//                 .map((notif) => {
//                   const { icon, 
//                     messageKey,
//                     messageParams 
//                     } = getNotificationIcon(notif, t);
//                   let message;
//                   if (notif.type === "order_updated") {
//                     // Reconstruct the message using translated parts for full detail and i18n support
//                     const base = t("notifications.messages.order_updated", {
//                       orderNumber: notif.orderNumber,
//                     });
//                     const parts = [];
//                     if (notif.priceDelta) {
//                       parts.push(
//                         t("notifications.messages.price_increase_part", {
//                           priceDelta: notif.priceDelta,
//                           newTotal: notif.newTotal || t("notifications.unknown"),
//                         })
//                       );
//                     }
//                     if (notif.minutesAdded) {
//                       const pluralSuffix = notif.minutesAdded === 1 ? "_one" : "_other";
//                       parts.push(
//                         t(`notifications.messages.time_extension_part${pluralSuffix}`, {
//                           minutesAdded: notif.minutesAdded,
//                           newDeadline: notif.newDeadline || t("notifications.unknown"),
//                         })
//                       );
//                     }
//                     message = base + (parts.length > 0 ? ": " + parts.join(" , ") : "") + ".";
//                   } else {
//                     message = t(messageKey, {
//                       ...messageParams,
//                       defaultValue: notif.message,
//                     });
//                   }
//                   return (
//                     <li
//                       key={notif.Id}
//                       className={`usernotificationdropdown-item position-relative ${
//                         notif.isRead ? "" : "usernotification-unread"
//                       }`}
//                       onClick={() => {
//                         handleMarkAsRead(notif.Id);
//                         navigate("/profile/notifications");
//                         setDropdownOpen(false);
//                       }}
//                     >
//                       <div className="usernotificationdropdown-icon-wrapper">
//                         <FontAwesomeIcon icon={icon} />
//                       </div>
//                       <div className="usernotificationdropdown-content">
//                         <p className="usernotificationdropdown-message">
//                           {/* {t(messageKey, {
//                             ...messageParams,
//                             defaultValue: notif.message,
//                           })} */}
//                           {/* {notif.message || ""}  */}
//                           {message}
//                         </p>
//                         <span className="usernotificationdropdown-time">
//                           {timeSince(notif.created_at)}
//                         </span>
//                       </div>
//                     </li>
//                   );
//                 })
//             ) : (
//               <li className="usernotificationdropdown-item">
//                 {t("notifications.no_notifications")}
//               </li>
//             )}

//             {notifications.length > 5 && (
//               <div className="usernotificationdropdown-show-toggle">
//                 <button type="button" onClick={toggleShowAll}>
//                   {showAll
//                     ? t("notifications.show_less")
//                     : t("notifications.show_all", {
//                         count: notifications.length,
//                       })}
//                 </button>
//               </div>
//             )}
//           </ul>

//           <div className="usernotificationdropdown-footer">
//             <Link
//               to="/profile/notifications"
//               className="usernotificationdropdown-view-all"
//               onClick={() => setDropdownOpen(false)}
//             >
//               {t("notifications.view_all")}
//             </Link>
//             {notifications.length > 0 && (
//               <button
//                 className="usernotificationdropdown-clear"
//                 onClick={handleMarkAllAsRead}
//               >
//                 {/* {t("notifications.clear_all")} */}
//                 {t("notifications.mark_all_as_read")}
//               </button>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UserNotificationDropdown;






// ***** New Updated for Add Notifications Sound (22-Sep-25) *****

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faBell,
//   faUserPlus,
//   faShoppingCart,
//   faCog,
//   faTrophy,   
//   faWallet,
// } from "@fortawesome/free-solid-svg-icons";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import "./notificationDropdown.css";
// import { useTranslation } from "react-i18next";

// // Helper function to convert a date into relative time (e.g., "5 min ago")
// function timeSince(dateString) {
//   const date = new Date(dateString);
//   const seconds = Math.floor((new Date() - date) / 1000);
//   if (seconds < 60) return `${seconds} sec${seconds !== 1 ? "s" : ""} ago`;
//   const minutes = Math.floor(seconds / 60);
//   if (minutes < 60) return `${minutes} min${minutes !== 1 ? "s" : ""} ago`;
//   const hours = Math.floor(minutes / 60);
//   if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
//   const days = Math.floor(hours / 24);
//   return `${days} day${days !== 1 ? "s" : ""} ago`;
// }

// const DING_STORAGE_KEY = "dingedNotifIds_v1"; // >>> NEW (versioned key)
// const MAX_IDS_TO_KEEP = 300;                   // >>> NEW (prevent growth)

// const UserNotificationDropdown = () => {
//   const { t } = useTranslation();

//   const [notifications, setNotifications] = useState([]);
//   const [showAll, setShowAll] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);

//   const audioRef = useRef(null);                     // >>> NEW
//   const dingedIdsRef = useRef(new Set());           // >>> NEW (persisted ids that already dinged)
//   const bootstrappedRef = useRef(false);            // >>> NEW (first poll after mount)

//   const dropdownRef = useRef(null);
//   const navigate = useNavigate();


//   // >>> NEW: load persisted dinged ids once on mount
//     useEffect(() => {
//       try {
//         const raw = localStorage.getItem(DING_STORAGE_KEY);
//         if (raw) {
//           const arr = JSON.parse(raw);
//           if (Array.isArray(arr)) arr.forEach((id) => dingedIdsRef.current.add(id));
//         }
//       } catch (_) {}
//     }, []);
  
//     // >>> NEW: stable play function (ESLint-safe)
//     const playDing = useCallback(() => {
//       const el = audioRef.current;
//       if (!el) return;
//       el.currentTime = 0;
//       el.play().catch(() => {}); // ignore autoplay errors
//     }, []);
  
//     // >>> NEW: persist current dinged set (trim to MAX_IDS_TO_KEEP)
//     const persistDingedIds = useCallback(() => {
//       const arr = Array.from(dingedIdsRef.current);
//       // keep only the most recent N (array order is insertion order for Sets converted to arrays in modern engines)
//       const trimmed = arr.slice(-MAX_IDS_TO_KEEP);
//       localStorage.setItem(DING_STORAGE_KEY, JSON.stringify(trimmed));
//       // also trim in-memory if we trimmed persisted list
//       if (trimmed.length !== arr.length) dingedIdsRef.current = new Set(trimmed);
//     }, []);

//   // Fetch notifications for the user
//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith("user-")
//             ? decodedToken.Id.split("user-")[1]
//             : decodedToken.Id;
//           const response = await axios.get(
//             `${URL}/notifications/user/${userId}`
//           );
//           if (response.status === 200) {
//             // setNotifications(response.data);
//             const enhancedNotifications = await Promise.all(
//               response.data.map(async (notif) => {
//                 let servitorFirstName,
//                   servitorLastName,
//                   priceDelta,
//                   newTotal,
//                   minutesAdded,
//                   newDeadline;
//                 // ADDED: Fetch servitor details for order_in_progress if recipientType is user
//                 if (
//                   notif.type === "order_in_progress" &&
//                   notif.recipientType === "user"
//                 ) {
//                   if (notif.servitorId) {
//                     try {
//                       const servitorResponse = await axios.get(
//                         `${URL}/servitors/${
//                           notif.servitorId.split("servitor-")[1]
//                         }`
//                       );
//                       if (servitorResponse.status === 200) {
//                         const servitorData = servitorResponse.data;
//                         servitorFirstName = servitorData.FirstName || "Unknown";
//                         servitorLastName = servitorData.LastName || "";
//                       } else {
//                         // ADDED: Fallback to parsing message with regex
//                         const match = notif.message.match(
//                           /accepted by ([^\s]+)\s*([^\s]*)/
//                         );
//                         servitorFirstName = match ? match[1] : "Unknown";
//                         servitorLastName = match ? match[2] : "";
//                       }
//                     } catch (error) {
//                       console.error("Error fetching servitor:", error);
//                       // ADDED: Fallback to parsing message with regex
//                       const match = notif.message.match(
//                         /accepted by ([^\s]+)\s*([^\s]*)/
//                       );
//                       servitorFirstName = match ? match[1] : "Unknown";
//                       servitorLastName = match ? match[2] : "";
//                     }
//                   } else {
//                     // ADDED: Fallback to parsing message with regex if no servitorId
//                     const match = notif.message.match(
//                       /accepted by ([^\s]+)\s*([^\s]*)/
//                     );
//                     servitorFirstName = match ? match[1] : "Unknown";
//                     servitorLastName = match ? match[2] : "";
//                   }
//                 }

//                 if (notif.type === "order_updated") {
//                   const d = notif.message?.match(/increased by\s*(\d+)\s*tk/i);
//                   const totalMatch = notif.message?.match(/New total price\s*(\d+)\s*tk/i);
//                   const m = notif.message?.match(/extended by\s*(\d+)\s*minute?s?/i);
//                   const to = notif.message?.match(/new deadline:\s*(.*?)\)/i);
//                   priceDelta = d ? parseInt(d[1], 10) : undefined;
//                   newTotal = totalMatch ? parseInt(totalMatch[1], 10) : undefined;
//                   minutesAdded = m ? parseInt(m[1], 10) : undefined;
//                   newDeadline = to ? to[1] : undefined;
//                 } else if (notif.type === "deadline_extended") {
//                  const m1 = notif.message?.match(/extended to\s*(.+?)(?:\.|$)/i);
//                  const m2 = notif.message?.match(/\(new deadline:\s*(.+?)\)/i);
//                  newDeadline = (m1 && m1[1]) || (m2 && m2[1]) || undefined;
//                 }

//                 return {
//                   ...notif,
//                   servitorFirstName,
//                   servitorLastName,
//                   priceDelta,
//                   newTotal,
//                   minutesAdded,
//                   newDeadline,

//                   rewardPoints:
//                   notif.type === "reward_points_awarded"
//                   ? (notif.message?.match(/earned\s+(\d+)\s+reward\s+point/i)?.[1] ? parseInt(notif.message.match(/earned\s+(\d+)\s+reward\s+point/i)[1], 10) : undefined)
//                   : undefined,
//                   claimAmount:
//                     notif.type === "reward_claimed"
//                       ? (notif.message?.match(/(\d+)\s*tk/i)?.[1] ? parseInt(notif.message.match(/(\d+)\s*tk/i)[1], 10) : undefined)
//                       : undefined,
//                   claimRef:
//                     notif.type === "reward_claimed"
//                       ? (notif.orderNumber || undefined)
//                       : undefined,
//                     };
//               })
//             );
//             setNotifications(enhancedNotifications);

//             // const unreadCount = response.data.filter((n) => !n.isRead).length;
//             const unreadCount = enhancedNotifications.filter((n) => !n.isRead).length;
//             setHasUnreadNotifications(unreadCount > 0);

//             // One-ding-per-id logic with persistence
//             const unreadNow = enhancedNotifications.filter((n) => !n.isRead);
//             const dinged = dingedIdsRef.current;

//             if (!bootstrappedRef.current) {
//               // FIRST poll after mount: record existing unread WITHOUT dinging
//               unreadNow.forEach((n) => dinged.add(n.Id));
//               bootstrappedRef.current = true;
//               persistDingedIds(); // >>> NEW
//               return;
//             }

//             // Next polls: ding once for any unread id that's not in dinged set
//             let shouldPlay = false;
//             for (const n of unreadNow) {
//               if (!dinged.has(n.Id)) {
//                 shouldPlay = true;
//                 dinged.add(n.Id);
//               }
//             }
//             if (shouldPlay) playDing(); // >>> will fire only once per fetch even if multiple new
//             persistDingedIds();         // >>> NEW

//           } else {
//             console.error("Failed to fetch notifications");
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       }
//     };

//     fetchNotifications();
//     const intervalId = setInterval(fetchNotifications, 60000); // Refresh every minute
//     return () => clearInterval(intervalId);
//   }, [playDing, persistDingedIds]);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setDropdownOpen(false);
//       }
//     };
//     if (dropdownOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//     } else {
//       document.removeEventListener("mousedown", handleClickOutside);
//     }
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownOpen]);

//   const toggleShowAll = () => {
//     setShowAll((prev) => !prev);
//   };

//   // Handler to mark a notification as read
//   const handleMarkAsRead = async (notificationId) => {
//     try {
//       const response = await axios.patch(
//         `${URL}/notifications/${notificationId}/read`
//       );
//       if (response.status === 200) {
//         // Update local state to mark this notification as read
//         setNotifications((prevNotifications) =>
//           prevNotifications.map((notif) =>
//             notif.Id === notificationId ? { ...notif, isRead: true } : notif
//           )
//         );
//       }
//     } catch (error) {
//       console.error("Error marking notification as read:", error);
//     }
//   };

//   const handleMarkAllAsRead = async () => {
//     const unread = notifications.filter((n) => !n.isRead);
//     await Promise.all(
//       unread.map((n) => axios.patch(`${URL}/notifications/${n.Id}/read`))
//     );
//     // Update local state in one go:
//     setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
//     setHasUnreadNotifications(false);
//   };

//   // const getNotificationIcon = (type) => {
//   //   // You can adjust the mapping based on your notification "type"
//   //   switch (type) {
//   //     case "order_accepted":
//   //       return faShoppingCart;
//   //     case "deadline_extended":
//   //       return faCog;
//   //     case "order_cancelled":
//   //       return faUserPlus;
//   //     default:
//   //       return faBell;
//   //   }
//   // };

//   const getNotificationIcon = (notif, t) => {
//     const defaults = {
//       icon: faBell,
//       messageKey:
//         notif.type === "service_update"
//           ? "notifications.messages.service_update"
//           : notif.type === "system"
//           ? "notifications.messages.system"
//           : "notifications.messages.notification_default",
//       messageParams: { orderNumber: notif.orderNumber || "" },
//     };

//     switch (notif.type) {
//       case "order_accepted":
//         return {
//           icon: faShoppingCart,
//           messageKey: "notifications.messages.order_accepted",
//           messageParams: { orderNumber: notif.orderNumber },
//         };
//       case "deadline_extended":
//         return {
//           icon: faCog,
//           messageKey: "notifications.messages.deadline_extended",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             // newDeadline: notif.newDeadline
//             // ? new Date(notif.newDeadline).toLocaleString()
//             // : "unknown",
//             newDeadline: notif.newDeadline || t("notifications.unknown"),
//           },
//         };
//       case "order_cancelled":
//         return {
//           icon: faUserPlus,
//           messageKey: notif.message?.includes("no servitor acceptance")
//             ? "notifications.messages.order_cancelled_timeout"
//             : notif.message?.includes("cancelled by the servitor")
//             ? "notifications.messages.order_cancelled_by_servitor"
//             : notif.message?.includes("cancelled by the user")
//             ? "notifications.messages.order_cancelled_by_user"
//             : "notifications.messages.order_cancelled_missed_deadline",
//           messageParams: { orderNumber: notif.orderNumber },
//         };
//       case "deadline_warning_pending":
//         return {
//           icon: faBell,
//           messageKey: "notifications.messages.deadline_warning_pending",
//           messageParams: { orderNumber: notif.orderNumber },
//         };
//       case "order_in_progress":
//         return {
//           icon: faBell,
//           messageKey:
//             notif.recipientType === "user"
//               ? "notifications.messages.order_in_progress_user"
//               : "notifications.messages.order_in_progress_servitor",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             servitorFirstName:
//               notif.servitorFirstName || t("notifications.unknown"),
//             servitorLastName: notif.servitorLastName || "",
//           },
//         };
//       case "order_completed":
//         return {
//           icon: faBell,
//           messageKey:
//             notif.recipientType === "user"
//               ? "notifications.messages.order_completed_user"
//               : "notifications.messages.order_completed_servitor",
//           messageParams: { orderNumber: notif.orderNumber },
//         };
//       case "penalty_applied":
//         return {
//           icon: faBell,
//           messageKey: "notifications.messages.penalty_applied",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             penaltyAmount: notif.penaltyAmount || 40,
//           },
//         };
//       case "account_blocked":
//         return {
//           icon: faBell,
//           messageKey: "notifications.messages.account_blocked",
//           messageParams: {
//             penaltyCount: notif.penaltyCount || 3,
//             penaltyAmount: notif.penaltyAmount || 90,
//           },
//         };
//       case "order_cancelled_with_penalty":
//         return {
//           icon: faBell,
//           messageKey: "notifications.messages.order_cancelled_with_penalty",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             penaltyAmount: notif.penaltyAmount || 30,
//             penaltyCount: notif.penaltyCount || 1,
//           },
//         };
//       case "order_time_warning":
//         return {
//           icon: faBell,
//           messageKey: "notifications.messages.order_time_warning",
//           messageParams: { orderNumber: notif.orderNumber },
//         };

//       case "tutor_accepted":
//         return {
//           icon: faUserPlus,
//           messageKey: "notifications.messages.tutor_accepted",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             servitorFirstName:
//               notif.servitorFirstName || t("notifications.unknown"),
//             servitorLastName: notif.servitorLastName || "",
//           },
//         };
//       case "tutor_user_approved":
//         return {
//           icon: faShoppingCart,
//           messageKey: "notifications.messages.tutor_user_approved",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             servitorFirstName:
//               notif.servitorFirstName || t("notifications.unknown"),
//             servitorLastName: notif.servitorLastName || "",
//           },
//         };
//       case "tutor_hired":
//         return {
//           icon: faCog,
//           messageKey: "notifications.messages.tutor_hired",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             servitorFirstName:
//               notif.servitorFirstName || t("notifications.unknown"),
//             servitorLastName: notif.servitorLastName || "",
//           },
//         };

//       // Optional: order_updated quick message in dropdown
//       case "order_updated":
//         return {
//           icon: faCog,
//           messageKey: "notifications.messages.order_updated",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             priceDelta: notif.priceDelta,
//             newTotal: notif.newTotal,
//             minutesAdded: notif.minutesAdded,
//             // newDeadline: notif.newDeadline
//             //   ? new Date(notif.newDeadline).toLocaleString()
//             //   : undefined,
//             newDeadline: notif.newDeadline
//               ? notif.newDeadline
//               : undefined,
//           },
//         };


//         case "reward_points_awarded":
//         return {
//           icon: faTrophy,
//           messageKey:
//             notif.recipientType === "servitor"
//               ? "notifications.messages.reward_points_awarded_servitor"
//               : "notifications.messages.reward_points_awarded_user",
//           messageParams: {
//             orderNumber: notif.orderNumber || t("notifications.unknown"),
//             points: notif.rewardPoints,
//           },
//         };

//       case "reward_claimed":
//         return {
//           icon: faWallet,
//           messageKey: "notifications.messages.reward_claimed",
//           messageParams: {
//             claimAmount: notif.claimAmount,
//             claimReference: notif.claimRef || t("notifications.unknown"),
//           },
//         };


//         case "order_rescheduled": {
//         // Parse schedule from message
//         const m1 = notif.message?.match(/rescheduled to\s*(.+?)\.?$/i);
//         const m2 = notif.message?.match(/new schedule:\s*(.+?)\.?$/i);
//         const m3 = notif.message?.match(/\(new deadline:\s*(.+?)\)/i);
//         const newSchedule = (m1 && m1[1]) || (m2 && m2[1]) || (m3 && m3[1]) || t("notifications.unknown");
//         return {
//           icon: faCog,
//           messageKey: "notifications.messages.order_rescheduled",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             newSchedule,
//           },
//         };
//       }
//       case "order_reordered": {
//         const m = notif.message?.match(/new schedule:\s*(.+?)\.?$/i);
//         const newSchedule = (m && m[1]) || t("notifications.unknown");
//         return {
//           icon: faCog,
//           messageKey: "notifications.messages.order_reordered",
//           messageParams: {
//             orderNumber: notif.orderNumber,
//             newSchedule,
//           },
//         };
//       }

//       default:
//         return defaults;
//     }
//   };

//   return (
//     <div className="usernotificationdropdown-container" ref={dropdownRef}>

//       {/* >>> NEW: Hidden audio element (always-on) */}
//       <audio ref={audioRef} preload="auto">
//         <source src="/sounds/notification.mp3" type="audio/mpeg" />
//       </audio>
      
//       <div
//         className={`usernotificationdropdown-icon ${
//           hasUnreadNotifications ? "bellShake" : ""
//         }`}
//         onClick={() => setDropdownOpen(!dropdownOpen)}
//       >
//         <FontAwesomeIcon icon={faBell} />
//         {notifications.some((n) => !n.isRead) && (
//           <span className="usernotificationdropdown-count">
//             {notifications.filter((n) => !n.isRead).length}
//           </span>
//         )}
//       </div>
//       {dropdownOpen && (
//         <div className="usernotificationdropdown-menu">
//           <div className="usernotificationdropdown-header">
//             <h6>{t("notifications.header")}</h6>
//             <span>
//               {t("notifications.new_count", {
//                 count: notifications.filter((n) => !n.isRead).length,
//               })}
//             </span>
//           </div>
//           <ul className="usernotificationdropdown-list">
//             {notifications.length > 0 ? (
//               notifications
//                 .slice(0, showAll ? notifications.length : 5)
//                 .map((notif) => {
//                   const { icon, 
//                     messageKey,
//                     messageParams 
//                     } = getNotificationIcon(notif, t);
//                   let message;
//                   if (notif.type === "order_updated") {
//                     // Reconstruct the message using translated parts for full detail and i18n support
//                     const base = t("notifications.messages.order_updated", {
//                       orderNumber: notif.orderNumber,
//                     });
//                     const parts = [];
//                     if (notif.priceDelta) {
//                       parts.push(
//                         t("notifications.messages.price_increase_part", {
//                           priceDelta: notif.priceDelta,
//                           newTotal: notif.newTotal || t("notifications.unknown"),
//                         })
//                       );
//                     }
//                     if (notif.minutesAdded) {
//                       const pluralSuffix = notif.minutesAdded === 1 ? "_one" : "_other";
//                       parts.push(
//                         t(`notifications.messages.time_extension_part${pluralSuffix}`, {
//                           minutesAdded: notif.minutesAdded,
//                           newDeadline: notif.newDeadline || t("notifications.unknown"),
//                         })
//                       );
//                     }
//                     message = base + (parts.length > 0 ? ": " + parts.join(" , ") : "") + ".";
//                   } else {
//                     message = t(messageKey, {
//                       ...messageParams,
//                       defaultValue: notif.message,
//                     });
//                   }
//                   return (
//                     <li
//                       key={notif.Id}
//                       className={`usernotificationdropdown-item position-relative ${
//                         notif.isRead ? "" : "usernotification-unread"
//                       }`}
//                       onClick={() => {
//                         handleMarkAsRead(notif.Id);
//                         navigate("/profile/notifications");
//                         setDropdownOpen(false);
//                       }}
//                     >
//                       <div className="usernotificationdropdown-icon-wrapper">
//                         <FontAwesomeIcon icon={icon} />
//                       </div>
//                       <div className="usernotificationdropdown-content">
//                         <p className="usernotificationdropdown-message">
//                           {/* {t(messageKey, {
//                             ...messageParams,
//                             defaultValue: notif.message,
//                           })} */}
//                           {/* {notif.message || ""}  */}
//                           {message}
//                         </p>
//                         <span className="usernotificationdropdown-time">
//                           {timeSince(notif.created_at)}
//                         </span>
//                       </div>
//                     </li>
//                   );
//                 })
//             ) : (
//               <li className="usernotificationdropdown-item">
//                 {t("notifications.no_notifications")}
//               </li>
//             )}

//             {notifications.length > 5 && (
//               <div className="usernotificationdropdown-show-toggle">
//                 <button type="button" onClick={toggleShowAll}>
//                   {showAll
//                     ? t("notifications.show_less")
//                     : t("notifications.show_all", {
//                         count: notifications.length,
//                       })}
//                 </button>
//               </div>
//             )}
//           </ul>

//           <div className="usernotificationdropdown-footer">
//             <Link
//               to="/profile/notifications"
//               className="usernotificationdropdown-view-all"
//               onClick={() => setDropdownOpen(false)}
//             >
//               {t("notifications.view_all")}
//             </Link>
//             {notifications.length > 0 && (
//               <button
//                 className="usernotificationdropdown-clear"
//                 onClick={handleMarkAllAsRead}
//               >
//                 {/* {t("notifications.clear_all")} */}
//                 {t("notifications.mark_all_as_read")}
//               </button>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UserNotificationDropdown;










// ***** New update with loader and 10 data limit (19-Oct-2025) ***** //
import React, { useState, useEffect, useRef, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faUserPlus,
  faShoppingCart,
  faCog,
  faTrophy,
  faWallet,
  faLifeRing,          
  faFlag
} from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { URL } from "../../../config";
import "./notificationDropdown.css";
import { useTranslation } from "react-i18next";

/* ---------- helpers ---------- */

// Normalize API payload (supports old array & new {data, hasMore} object)
const normalizeNotifResponse = (payload) => {
  if (Array.isArray(payload)) {
    return { data: payload, hasMore: false, page: 1, limit: payload.length || 0 };
  }
  if (Array.isArray(payload?.data)) {
    return {
      data: payload.data,
      hasMore: Boolean(payload.hasMore),
      page: Number(payload.page) || 1,
      limit: Number(payload.limit) || 10,
    };
  }
  return { data: [], hasMore: false, page: 1, limit: 0 };
};

// Helper function to convert a date into relative time (e.g., "5 min ago")
function timeSince(dateString) {
  const date = new Date(dateString);
  const seconds = Math.floor((new Date() - date) / 1000);
  if (seconds < 60) return `${seconds} sec${seconds !== 1 ? "s" : ""} ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min${minutes !== 1 ? "s" : ""} ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
  const days = Math.floor(hours / 24);
  return `${days} day${days !== 1 ? "s" : ""} ago`;
}

const DEFAULT_CANCEL_LIMIT = 3;
const DING_STORAGE_KEY = "dingedNotifIds_v1";
const MAX_IDS_TO_KEEP = 300;

const UserNotificationDropdown = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [notifications, setNotifications] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);

  const audioRef = useRef(null);
  const dingedIdsRef = useRef(new Set());
  const bootstrappedRef = useRef(false);
  const dropdownRef = useRef(null);

  // Load persisted dinged ids once
  useEffect(() => {
    try {
      const raw = localStorage.getItem(DING_STORAGE_KEY);
      if (raw) {
        const arr = JSON.parse(raw);
        if (Array.isArray(arr)) arr.forEach((id) => dingedIdsRef.current.add(id));
      }
    } catch (_) {}
  }, []);

  const playDing = useCallback(() => {
    const el = audioRef.current;
    if (!el) return;
    el.currentTime = 0;
    el.play().catch(() => {});
  }, []);

  const persistDingedIds = useCallback(() => {
    const arr = Array.from(dingedIdsRef.current);
    const trimmed = arr.slice(-MAX_IDS_TO_KEEP);
    localStorage.setItem(DING_STORAGE_KEY, JSON.stringify(trimmed));
    if (trimmed.length !== arr.length) dingedIdsRef.current = new Set(trimmed);
  }, []);

  // Fetch notifications (page 1, limit 10 for dropdown)
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const decodedToken = jwtDecode(token);
        const userId = decodedToken.Id?.startsWith?.("user-")
          ? decodedToken.Id.split("user-")[1]
          : decodedToken.Id;

        const { data: raw } = await axios.get(
          `${URL}/notifications/user/${userId}?page=1&limit=10`
        );

        const { data } = normalizeNotifResponse(raw);

        // Enhance items (parsing + optional servitor name for order_in_progress)
        const enhanced = await Promise.all(
          data.map(async (notif) => {
            let servitorFirstName,
              servitorLastName,
              priceDelta,
              newTotal,
              minutesAdded,
              newDeadline,
              penaltyCount, 
              limit;

            if (notif.type === "order_in_progress" && notif.recipientType === "user") {
              if (notif.servitorId) {
                try {
                  const cleanId = String(notif.servitorId).includes("servitor-")
                    ? notif.servitorId.split("servitor-")[1]
                    : notif.servitorId;
                  const servitorResponse = await axios.get(`${URL}/servitors/${cleanId}`);
                  if (servitorResponse.status === 200) {
                    const s = servitorResponse.data;
                    servitorFirstName = s.FirstName || "Unknown";
                    servitorLastName = s.LastName || "";
                  } else {
                    const m = notif.message?.match?.(/accepted by ([^\s]+)\s*([^\s]*)/);
                    servitorFirstName = m ? m[1] : "Unknown";
                    servitorLastName = m ? m[2] : "";
                  }
                } catch {
                  const m = notif.message?.match?.(/accepted by ([^\s]+)\s*([^\s]*)/);
                  servitorFirstName = m ? m[1] : "Unknown";
                  servitorLastName = m ? m[2] : "";
                }
              } else {
                const m = notif.message?.match?.(/accepted by ([^\s]+)\s*([^\s]*)/);
                servitorFirstName = m ? m[1] : "Unknown";
                servitorLastName = m ? m[2] : "";
              }
            }

            // ✅ NEW: parse cancel warning / blocked limit + count from message (fallback)
              if (notif.type === "order_cancelled_with_penalty") {
                const countMatchOld = notif.message?.match?.(/Cancellation count:\s*(\d+)/i);
                const countMatchNew = notif.message?.match?.(/Count:\s*(\d+)\s*\/\s*(\d+)/i);

                penaltyCount =
                  typeof notif.penaltyCount === "number"
                    ? notif.penaltyCount
                    : countMatchNew
                    ? parseInt(countMatchNew[1], 10)
                    : countMatchOld
                    ? parseInt(countMatchOld[1], 10)
                    : undefined;

                limit =
                  typeof notif.limit === "number"
                    ? notif.limit
                    : countMatchNew
                    ? parseInt(countMatchNew[2], 10)
                    : undefined;
              }

              if (notif.type === "account_blocked") {
                const m = notif.message?.match?.(/\((\d+)\s*\/\s*(\d+)\)/);

                penaltyCount =
                  typeof notif.penaltyCount === "number"
                    ? notif.penaltyCount
                    : m
                    ? parseInt(m[1], 10)
                    : undefined;

                limit =
                  typeof notif.limit === "number"
                    ? notif.limit
                    : m
                    ? parseInt(m[2], 10)
                    : undefined;
              }


            if (notif.type === "order_updated") {
              const d = notif.message?.match?.(/increased by\s*(\d+)\s*tk/i);
              const totalMatch = notif.message?.match?.(/New total price\s*(\d+)\s*tk/i);
              const m = notif.message?.match?.(/extended by\s*(\d+)\s*minute?s?/i);
              const to = notif.message?.match?.(/new deadline:\s*(.*?)\)/i);
              priceDelta = d ? parseInt(d[1], 10) : undefined;
              newTotal = totalMatch ? parseInt(totalMatch[1], 10) : undefined;
              minutesAdded = m ? parseInt(m[1], 10) : undefined;
              newDeadline = to ? to[1] : undefined;
            } else if (notif.type === "deadline_extended") {
              const m1 = notif.message?.match?.(/extended to\s*(.+?)(?:\.|$)/i);
              const m2 = notif.message?.match?.(/\(new deadline:\s*(.+?)\)/i);
              newDeadline = (m1 && m1[1]) || (m2 && m2[1]) || undefined;
            }

            // Reward points / claimed parsing (fallback if backend didn’t add fields)
            const rewardPoints =
              notif.type === "reward_points_awarded"
                ? (() => {
                    const mm = notif.message?.match?.(/earned\s+(\d+)\s+(?:reward\s+)?points?/i);
                    return mm ? parseInt(mm[1], 10) : undefined;
                  })()
                : undefined;

            const claimAmount =
              notif.type === "reward_claimed"
                ? (() => {
                    const mm = notif.message?.match?.(/(\d+)\s*tk/i);
                    return mm ? parseInt(mm[1], 10) : undefined;
                  })()
                : undefined;

            const claimRef =
              notif.type === "reward_claimed"
                ? notif.orderNumber || undefined
                : undefined;

            if (notif.type === "reward_claimed") {
              const baseDiscount = notif.discountValue ?? notif.meta?.discountValue;
              const baseTier = notif.tierLabel ?? notif.meta?.tierLabel;
              const baseCode = notif.code ?? notif.meta?.code;
              const baseRemaining = notif.remainingPoints ?? notif.meta?.remainingPoints;

              const msg = notif.message || "";

              // Support both “discount 20 tk” and “worth 20 tk”
              const amountMatch = msg.match(/(?:discount|worth)\s*(\d+)\s*tk/i);
              const codeMatch = msg.match(/\(([A-Za-z0-9-]+)\)\s*claimed/i);
              const tierMatch = msg.match(/^([^)]+?)\s*Coupon/i);
              const remainingMatch = msg.match(/(\d+)\s*points?\s*remain/i);

              const dv2 =
                typeof baseDiscount === "number"
                  ? baseDiscount
                  : amountMatch
                  ? parseInt(amountMatch[1], 10)
                  : undefined;

              const cd2 = baseCode || (codeMatch ? codeMatch[1] : undefined);
              const tl2 = baseTier || (tierMatch ? tierMatch[1] : undefined);
              const rp2 =
                typeof baseRemaining === "number"
                  ? baseRemaining
                  : remainingMatch
                  ? parseInt(remainingMatch[1], 10)
                  : undefined;

              notif.discountValue = dv2;
              notif.tierLabel = tl2;
              notif.code = cd2;
              notif.remainingPoints = rp2;
            }


            return {
              ...notif,
              servitorFirstName,
              servitorLastName,
              priceDelta,
              newTotal,
              minutesAdded,
              newDeadline,
              rewardPoints,
              claimAmount,
              claimRef,
              penaltyCount,
              limit,
            };
          })
        );

        setNotifications(enhanced);

        const unreadCount = enhanced.filter((n) => !n.isRead).length;
        setHasUnreadNotifications(unreadCount > 0);

        // One-ding-per-id logic with persistence
        const unreadNow = enhanced.filter((n) => !n.isRead);
        const dinged = dingedIdsRef.current;

        if (!bootstrappedRef.current) {
          // FIRST poll after mount: record existing unread WITHOUT dinging
          unreadNow.forEach((n) => dinged.add(n.Id));
          bootstrappedRef.current = true;
          persistDingedIds();
          return;
        }

        let shouldPlay = false;
        for (const n of unreadNow) {
          if (!dinged.has(n.Id)) {
            shouldPlay = true;
            dinged.add(n.Id);
          }
        }
        if (shouldPlay) playDing();
        persistDingedIds();
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchNotifications();
    const intervalId = setInterval(fetchNotifications, 60000); // Refresh every minute
    return () => clearInterval(intervalId);
  }, [playDing, persistDingedIds]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  const toggleShowAll = () => setShowAll((prev) => !prev);

  // Mark a single notification as read
  const handleMarkAsRead = async (notificationId) => {
    try {
      const response = await axios.patch(`${URL}/notifications/${notificationId}/read`);
      if (response.status === 200) {
        setNotifications((prev) =>
          prev.map((notif) => (notif.Id === notificationId ? { ...notif, isRead: true } : notif))
        );
      }
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const handleMarkAllAsRead = async () => {
    const unread = notifications.filter((n) => !n.isRead);
    await Promise.all(unread.map((n) => axios.patch(`${URL}/notifications/${n.Id}/read`)));
    setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
    setHasUnreadNotifications(false);
  };


const deriveFullBuildingStatus = (notif) => {
  const msg = (notif.message || "").toLowerCase();

  if (!msg) return "";

  if (msg.includes("pending")) return "pending";
  if (msg.includes("under review")) return "in_review";
  if (msg.includes("scheduled site visit") || msg.includes("site visit")) {
    // if you're using specific wording for site visit
    return "site_visit_scheduled";
  }
  if (msg.includes("quotation") && msg.includes("shared")) {
    return "quotation_shared";
  }
  if (msg.includes("approved")) return "approved";
  if (msg.includes("completed")) return "completed";
  if (msg.includes("cancelled") || msg.includes("canceled")) return "cancelled";

  return "";
};


  const getNotificationIcon = (notif, t) => {
    const defaults = {
      icon: faBell,
      messageKey:
        notif.type === "service_update"
          ? "notifications.messages.service_update"
          : notif.type === "system"
          ? "notifications.messages.system"
          : "notifications.messages.notification_default",
      messageParams: { orderNumber: notif.orderNumber || "" },
    };

    switch (notif.type) {
      case "order_accepted":
        return {
          icon: faShoppingCart,
          messageKey: "notifications.messages.order_accepted",
          messageParams: { orderNumber: notif.orderNumber },
        };
      case "deadline_extended":
        return {
          icon: faCog,
          messageKey: "notifications.messages.deadline_extended",
          messageParams: {
            orderNumber: notif.orderNumber,
            newDeadline: notif.newDeadline || t("notifications.unknown"),
          },
        };
      case "order_cancelled":
        return {
          icon: faUserPlus,
          messageKey: notif.message?.includes?.("no servitor acceptance")
            ? "notifications.messages.order_cancelled_timeout"
            : notif.message?.includes?.("cancelled by the servitor")
            ? "notifications.messages.order_cancelled_by_servitor"
            : notif.message?.includes?.("cancelled by the user")
            ? "notifications.messages.order_cancelled_by_user"
            : "notifications.messages.order_cancelled_missed_deadline",
          messageParams: { orderNumber: notif.orderNumber },
        };
      case "deadline_warning_pending":
        return {
          icon: faBell,
          messageKey: "notifications.messages.deadline_warning_pending",
          messageParams: { orderNumber: notif.orderNumber },
        };
      case "order_in_progress":
        return {
          icon: faBell,
          messageKey:
            notif.recipientType === "user"
              ? "notifications.messages.order_in_progress_user"
              : "notifications.messages.order_in_progress_servitor",
          messageParams: {
            orderNumber: notif.orderNumber,
            servitorFirstName: notif.servitorFirstName || t("notifications.unknown"),
            servitorLastName: notif.servitorLastName || "",
          },
        };
      case "order_completed":
        return {
          icon: faBell,
          messageKey:
            notif.recipientType === "user"
              ? "notifications.messages.order_completed_user"
              : "notifications.messages.order_completed_servitor",
          messageParams: { orderNumber: notif.orderNumber },
        };

      case "order_created_by_admin": {
        const serviceTypeFromMeta =
          notif.meta?.serviceType || notif.services_name || notif.serviceType;

        const serviceTypeFromMessage = (() => {
          const m = (notif.message || "").match(/placed your\s+(.+?)\s+order/i);
          return m ? m[1] : "";
        })();

        return {
          icon: faShoppingCart,
          messageKey: "notifications.messages.order_created_by_admin",
          messageParams: {
            serviceType:
              serviceTypeFromMeta || serviceTypeFromMessage || t("notifications.unknown"),
            orderNumber: notif.orderNumber || "",
          },
        };
      }

      case "penalty_applied":
        return {
          icon: faBell,
          messageKey: "notifications.messages.penalty_applied",
          messageParams: {
            orderNumber: notif.orderNumber,
            penaltyAmount: notif.penaltyAmount || 40,
          },
        };
      case "account_blocked":
        return {
          icon: faBell,
          messageKey: "notifications.messages.account_blocked",
          messageParams: {
            penaltyCount: notif.penaltyCount || 3,
            // penaltyAmount: notif.penaltyAmount || 90,
            limit: notif.limit ?? DEFAULT_CANCEL_LIMIT,
          },
        };
      case "order_cancelled_with_penalty":
        return {
          icon: faBell,
          messageKey: "notifications.messages.order_cancelled_with_penalty",
          messageParams: {
            orderNumber: notif.orderNumber,
            penaltyAmount: notif.penaltyAmount || 30,
            penaltyCount: notif.penaltyCount || 1,
            limit: notif.limit ?? DEFAULT_CANCEL_LIMIT,
          },
        };
      case "order_time_warning":
        return {
          icon: faBell,
          messageKey: "notifications.messages.order_time_warning",
          messageParams: { orderNumber: notif.orderNumber },
        };

        case "order_assigned":
        return {
          icon: faUserPlus,
          messageKey: "notifications.messages.order_assigned",
          messageParams: {
            orderNumber: notif.orderNumber,
          },
        };

      case "tutor_accepted":
        return {
          icon: faUserPlus,
          messageKey: "notifications.messages.tutor_accepted",
          messageParams: {
            orderNumber: notif.orderNumber,
            servitorFirstName: notif.servitorFirstName || t("notifications.unknown"),
            servitorLastName: notif.servitorLastName || "",
          },
        };
      case "tutor_user_approved":
        return {
          icon: faShoppingCart,
          messageKey: "notifications.messages.tutor_user_approved",
          messageParams: {
            orderNumber: notif.orderNumber,
            servitorFirstName: notif.servitorFirstName || t("notifications.unknown"),
            servitorLastName: notif.servitorLastName || "",
          },
        };
      case "tutor_hired":
        return {
          icon: faCog,
          messageKey: "notifications.messages.tutor_hired",
          messageParams: {
            orderNumber: notif.orderNumber,
            servitorFirstName: notif.servitorFirstName || t("notifications.unknown"),
            servitorLastName: notif.servitorLastName || "",
          },
        };
      case "order_updated":
        return {
          icon: faCog,
          messageKey: "notifications.messages.order_updated",
          messageParams: {
            orderNumber: notif.orderNumber,
            priceDelta: notif.priceDelta,
            newTotal: notif.newTotal,
            minutesAdded: notif.minutesAdded,
            newDeadline: notif.newDeadline ? notif.newDeadline : undefined,
          },
        };
      case "reward_points_awarded":
        return {
          icon: faTrophy,
          messageKey:
            notif.recipientType === "servitor"
              ? "notifications.messages.reward_points_awarded_servitor"
              : "notifications.messages.reward_points_awarded_user",
          messageParams: {
            orderNumber: notif.orderNumber || t("notifications.unknown"),
            // points: notif.rewardPoints,
            count: notif.rewardPoints,
          },
        };
      case "reward_claimed":
        return {
          icon: faWallet,
          messageKey: "notifications.messages.reward_claimed_coupon",
          messageParams: {
            code: notif.code || t("notifications.unknown"),
            tierLabel: notif.tierLabel || t("notifications.unknown"),
            discountValue:
              typeof notif.discountValue === "number"
                ? notif.discountValue
                : t("notifications.unknown"),
            remainingPoints:
              typeof notif.remainingPoints === "number"
                ? notif.remainingPoints
                : t("notifications.unknown"),
          },
        };

      case "order_rescheduled": {
        const m1 = notif.message?.match?.(/rescheduled to\s*(.+?)\.?$/i);
        const m2 = notif.message?.match?.(/new schedule:\s*(.+?)\.?$/i);
        const m3 = notif.message?.match?.(/\(new deadline:\s*(.+?)\)/i);
        const newSchedule =
          (m1 && m1[1]) || (m2 && m2[1]) || (m3 && m3[1]) || t("notifications.unknown");
        return {
          icon: faCog,
          messageKey: "notifications.messages.order_rescheduled",
          messageParams: { orderNumber: notif.orderNumber, newSchedule },
        };
      }
      case "order_reordered": {
        const m = notif.message?.match?.(/new schedule:\s*(.+?)\.?$/i);
        const newSchedule = (m && m[1]) || t("notifications.unknown");
        return {
          icon: faCog,
          messageKey: "notifications.messages.order_reordered",
          messageParams: { orderNumber: notif.orderNumber, newSchedule },
        };
      }


      case "report_received":
      return {
        icon: faLifeRing,
        messageKey: "notifications.messages.report_received",
        messageParams: { orderNumber: notif.orderNumber },
      };

    case "report_opened_counterparty":
      return {
        icon: faFlag,
        messageKey: "notifications.messages.report_opened_counterparty",
        messageParams: { orderNumber: notif.orderNumber },
      };

      case "report_closed": {
        // translate raw status -> label
        const raw = notif.status || notif.message?.match?.(/\bis (\w+)\b/i)?.[1] || "resolved";
        const statusLabel = t(`notifications.status.${raw}`, raw);

        return {
          icon: faLifeRing, // good semantic match: support/report lifecycle
          messageKey: "notifications.messages.report_closed",
          messageParams: {
            orderNumber: notif.orderNumber,
            status: statusLabel,
          },
        };
      }

      /* 🔹 NEW: full building request created */
    case "full_building_request_created":
      return {
        icon: faBell,
        messageKey: "notifications.messages.full_building_request_created",
        messageParams: {
          orderNumber: notif.orderNumber || t("notifications.unknown"),
        },
      };

    /* 🔹 NEW: full building status updated */
    case "full_building_status_updated": {
      let raw = (notif.status || "").toLowerCase();
      if (!raw) {
        raw = deriveFullBuildingStatus(notif);  // 🔹 fallback for old rows
      }

      const statusLabel = raw
        ? t(`notifications.full_building_status.${raw}`, { defaultValue: raw })
        : t("notifications.unknown");

      return {
        icon: faCog,
        messageKey: "notifications.messages.full_building_status_updated",
        messageParams: {
          orderNumber: notif.orderNumber || t("notifications.unknown"),
          status: statusLabel,
        },
      };
    }

      default:
        return defaults;
    }
  };

  return (
    <div className="usernotificationdropdown-container" ref={dropdownRef}>
      {/* Hidden audio element */}
      <audio ref={audioRef} preload="auto">
        <source src="/sounds/notification.mp3" type="audio/mpeg" />
      </audio>

      <div
        className={`usernotificationdropdown-icon ${hasUnreadNotifications ? "bellShake" : ""}`}
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        <FontAwesomeIcon icon={faBell} />
        {notifications.some((n) => !n.isRead) && (
          <span className="usernotificationdropdown-count">
            {notifications.filter((n) => !n.isRead).length}
          </span>
        )}
      </div>

      {dropdownOpen && (
        <div className="usernotificationdropdown-menu">
          <div className="usernotificationdropdown-header">
            <h6>{t("notifications.header")}</h6>
            <span>
              {t("notifications.new_count", {
                count: notifications.filter((n) => !n.isRead).length,
              })}
            </span>
          </div>

          <ul className="usernotificationdropdown-list">
            {notifications.length > 0 ? (
              notifications
                .slice(0, showAll ? notifications.length : 5)
                .map((notif) => {
                  const { icon, messageKey, messageParams } = getNotificationIcon(notif, t);
                  let message;
                  if (notif.type === "order_updated") {
                    const base = t("notifications.messages.order_updated", {
                      orderNumber: notif.orderNumber,
                    });
                    const parts = [];
                    if (notif.priceDelta) {
                      parts.push(
                        t("notifications.messages.price_increase_part", {
                          priceDelta: notif.priceDelta,
                          newTotal: notif.newTotal || t("notifications.unknown"),
                        })
                      );
                    }
                    if (notif.minutesAdded) {
                      const pluralSuffix = notif.minutesAdded === 1 ? "_one" : "_other";
                      parts.push(
                        t(`notifications.messages.time_extension_part${pluralSuffix}`, {
                          minutesAdded: notif.minutesAdded,
                          newDeadline: notif.newDeadline || t("notifications.unknown"),
                        })
                      );
                    }
                    message = base + (parts.length > 0 ? ": " + parts.join(" , ") : "") + ".";
                  } else {
                    message = t(messageKey, {
                      ...messageParams,
                      defaultValue: notif.message,
                    });
                  }

                  return (
                    <li
                      key={notif.Id}
                      className={`usernotificationdropdown-item position-relative ${
                        notif.isRead ? "" : "usernotification-unread"
                      }`}
                      onClick={() => {
                        handleMarkAsRead(notif.Id);
                        navigate("/profile/notifications");
                        setDropdownOpen(false);
                      }}
                    >
                      <div className="usernotificationdropdown-icon-wrapper">
                        <FontAwesomeIcon icon={icon} />
                      </div>
                      <div className="usernotificationdropdown-content">
                        <p className="usernotificationdropdown-message">{message}</p>
                        <span className="usernotificationdropdown-time">
                          {timeSince(notif.created_at)}
                        </span>
                      </div>
                    </li>
                  );
                })
            ) : (
              <li className="usernotificationdropdown-item">
                {t("notifications.no_notifications")}
              </li>
            )}

            {notifications.length > 5 && (
              <div className="usernotificationdropdown-show-toggle">
                <button type="button" onClick={toggleShowAll}>
                  {showAll
                    ? t("notifications.show_less")
                    : t("notifications.show_all", { count: notifications.length })}
                </button>
              </div>
            )}
          </ul>

          <div className="usernotificationdropdown-footer">
            <Link
              to="/profile/notifications"
              className="usernotificationdropdown-view-all"
              onClick={() => setDropdownOpen(false)}
            >
              {t("notifications.view_all")}
            </Link>
            {notifications.length > 0 && (
              <button className="usernotificationdropdown-clear" onClick={handleMarkAllAsRead}>
                {t("notifications.mark_all_as_read")}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserNotificationDropdown;
